module.exports = __webpack_public_path__ + "static/media/Werner Ave Daly City, CA (3 Houses)1.99ca20c9.jpg";